import axios from "axios";
import { get as getCookie } from "js-cookie";

const baseURL = process.env.VUE_APP_API || "/api";
const token = getCookie("jwt");
const Authorization = token ? `Bearer ${token}` : null;
const instance = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    common: {
      "Access-Control-Allow-Origin": true,
      "Access-Control-Allow-Credentials": true,
      Authorization
    }
  }
});

instance.interceptors.response.use(
  res => {
    if (res.status === 401) {
      console.error("401 Unauthorized");
    }
    return res;
  },
  error => {
    if (error.response && error.response.data) {
      return Promise.reject(error.response.data);
    }

    return Promise.reject(error.message);
  }
);

export default instance;
